module.exports = __webpack_public_path__ + "static/img/client-bannger.6ebc5e4.png";